<template>
 
  <div class="q-pa-md q-mt-lg">
    <!-- <div class="loaderClass" v-if="isLoading">
           <q-spinner-cube color="blue" size="6em"/>
    </div> -->
    <!-- <div class="q-pa-md" v-if="!isLoading && data.length != 0"> -->
    
    <q-tabs
        v-model="tab"
        indicator-color="blue"
        class="text-teal  q-mt-xl"
        align="left"
         >
        <q-tab name="history"  label="history"></q-tab>
        <q-tab name="recent"  label="recent"></q-tab>
       

      </q-tabs>

      <div v-if="tab==='recent'">
        <div class="introWindow">
        <q-table
        :loading="isLoading"
        ref="table"
        title="Price Optimization Results History"
        :class="expanded===true?'tabl':'tbl'"
        :data = "rows"
        :columns="columns"
        :hide-pagination="true"
        no-data-label="No Result History Found"
      >
       
      <template v-if="isLoading===false" v-slot:top-row>
        <q-th align="left" bold :style="{fontsize:'40px',color:'red'}">
          New Job ↓
        </q-th>
        </template>

        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr :props="props" >
            <q-td key="id" :props="props">
              Inventory_Optimization_Job_{{ props.row.jobnum}}
            </q-td>

            <q-td key="created_at" :props="props">
           
              {{(props.row.created_at)||(props.row.created_at)!= undefined ?new Date(props.row.created_at).toLocaleString():'No Data'}}
            </q-td>
             <q-td key="request_type" :props="props">
           
              {{(props.row.request_type)}}
            </q-td>

            <q-td key="job_details" :props="props">
              <q-td auto-width>
                <q-btn
                  size="sm"
                  color="blue"
                  round
                  @click="expanded = !expanded"
                  :icon="expanded? 'remove' : 'add'"
                />
              </q-td>
            </q-td>

            <q-td key="status" :props="props">
              <span
                v-if="
                  'SUBMITTED' === props.row.status ||
                  'PROCESSING' === props.row.status
                "
                ><div class="box-m">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>

              <span
                v-if="
                  'READY' === props.row.status"
                ><div class="box-h">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>
              
            </q-td>

            <q-td auto-width>
              <!-- <router-link :to="{ name: 'PriceOptimizationResults', params: { jobid: props.row.id }}"> -->
              <q-btn v-if="props.row.status === 'READY'"
                unelevated
                size="12px"
                rounded
                color="blue"
                label="Show Result"
                class="text-white"
                @click="showResult(props.row.id)"
              />
              <q-btn v-if="props.row.status === 'SUBMITTED' ||
                  'PROCESSING' === props.row.status"
                 unelevated
                size="12px"
                rounded
                color="black"
                class="generate"
                label="Generating"
              />
              <!-- </router-link> -->
              
                <!-- <q-linear-progress
                 v-if="props.row.status === 'SUBMITTED' ||'PROCESSING' === props.row.status"
                 rounded
                 stripe
                size="15px" 
                :value="props.row.job_progress" >
               <div class="absolute-full flex flex-center">
        <q-badge  outline="hidden" text-color="black" :label="(props.row.job_progress)*100 + '%'"></q-badge>
      </div>
                </q-linear-progress> -->

                </q-td>
          </q-tr>
          <q-tr v-show="expanded" :props="props">
            <q-td colspan="100%">
              <q-table
                title="Optimised Details"
                :data="props.row.job_details[0]['shop']"
                :columns="columns2"
                row-key="name"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      </div>

      </div>
      <div v-else>
    <div class="introWindow">
      <q-table
        :loading="isLoading"
        ref="table"
        title="Inventory Optimization Results History"
         class="my-sticky-virtscroll-table"
         virtual-scroll
        :virtual-scroll-sticky-size-start="48"
        :data="data"
        :columns="columns"
        no-data-label="No Result History Found"
      >
       
      <template v-if="isLoading===false" v-slot:top-row>
        <q-th align="left" bold :style="{fontsize:'40px',color:'red'}">
          New Job ↓
        </q-th>
        </template>

        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="id" :props="props">
              Inventory_Optimization_Job_{{ props.row.jobnum }}
            </q-td>

            <q-td key="created_at" :props="props">
           
              {{(props.row.created_at)||(props.row.created_at)!= undefined ?new Date(props.row.created_at).toLocaleString():'No Data'}}
            </q-td>
             <q-td key="request_type" :props="props">
           
              {{(props.row.request_type)}}
            </q-td>

            <q-td key="job_details" :props="props">
              <q-td auto-width>
                <q-btn
                  size="sm"
                  color="blue"
                  round
                  @click="props.expand = !props.expand"
                  :icon="props.expand ? 'remove' : 'add'"
                />
              </q-td>
            </q-td>

            <q-td key="status" :props="props">
              <span
                v-if="
                  'SUBMITTED' === props.row.status ||
                  'PROCESSING' === props.row.status
                "
                ><div class="box-m">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>

              <span
                v-if="
                  'READY' === props.row.status"
                ><div class="box-h">
                  <strong>{{ props.row.status }}</strong>
                </div>
              </span>
              
            </q-td>

            <q-td auto-width>
              <!-- <router-link :to="{ name: 'PriceOptimizationResults', params: { jobid: props.row.id }}"> -->
              <q-btn v-if="props.row.status === 'READY'"
                unelevated
                size="12px"
                rounded
                color="blue"
                label="Show Result"
                class="text-white"
                @click="showResult(props.row.id)"
              />
              <q-btn v-if="props.row.status === 'SUBMITTED' ||
                  'PROCESSING' === props.row.status"
                 unelevated
                size="12px"
                rounded
                color="black"
                class="generate"
                label="Generating"
              />
              <!-- </router-link> -->
              
                <!-- <q-linear-progress
                 v-if="props.row.status === 'SUBMITTED' ||'PROCESSING' === props.row.status"
                 rounded
                 stripe
                size="15px" 
                :value="props.row.job_progress" >
               <div class="absolute-full flex flex-center">
        <q-badge  outline="hidden" text-color="black" :label="(props.row.job_progress)*100 + '%'"></q-badge>
      </div>
                </q-linear-progress> -->

                </q-td>
          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <q-table
                title="Optimised Details"
                :data="props.row.job_details[0]['shop']"
                :columns="columns2"
                row-key="name"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      tab:"history",
      expanded:true,
      last_data:0,
      
      columns: [
        {
          name: "id",
          align: "left",
          label: "Job Submission Number",
          field: "id",
          sortable: true,
        },
        {
          name: "created_at",
          label: "Job Submission Time",
          field: "created_at",
          align: "left",
          sortable: true,
        },
        {
          name: "request_type",
          label: "Type",
          field: "request_type",
          align: "left",
          sortable: true,
        },
        {
          name: "job_details",
          label: "Optim Details",
          field: "job_details",
          align: "left",
        },
         {
          name: "status",
          label: "Status",
          field: "status",
          align: "center",
        },
        {
          name: "job_progress",
          label: "Job progress",
          field: "job_progress",
          align: "center",
          hidden:true,
        },
      ],
      columns2: [
        {
          name: "forecastrequired",
          align: "left",
          label: "Forecast Required",
          field: "forecastrequired",
          sortable: true,
        },
        {
          name: "maximumbudget",
          label: "Maximum Budget",
          field: "maximumbudget",
          align: "left",
        },
        {
          name: "shop",
          label: "Shop",
          field: "shop",
          align: "left",
        },

      ],
     
      data: [],
      lis: [],
      rows:[],
    };
  },

  created() {
     var resultshistoryURL = this.api_url + "/resultshistory/inventoryhistory";
     
    this.$http
      .get(resultshistoryURL)
      .then((response) => {
        let result = response.data;
        // console.log(response.data);
        let data = result.map((items) => {
          return {
            ...items,
            //jobnum: count++
          };
        });
        let count = data.length;
        this.last_data = data.length;
       //const sortedData = data.slice().sort(function(a,b){let c = new Date(a.created_at); let d = new Date(b.created_at); return c-d});
       const sortedData = data.slice().sort(function(a,b){let c = new Date(a.created_at); let d = new Date(b.created_at); return d-c}).map((items)=>{
         return {
            ...items,
            jobnum: count--
          };
        });
    
         console.log(sortedData)
        this.data = sortedData;
        this.isLoading = false;
        this.rows[0] = this.data[0];   
         console.log(this.rows[0])     
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        // console.log(err);
      });
   

     
      
      
  },
  mounted(){
    this.$q.loading.show({
       message: "Authenticating please wait..",
     });


      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/inventoryoptimization/inventoryresult");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else  if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/inventoryoptimization/inventoryresult");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else{
       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
     }
  },
  methods: {
     reload(){
        if(this.data[0]['status'] === 'SUBMITTED'){
          setInterval(window.location.reload(),20000);
        }
     },
    showResult(data) {
      // const id = this.data[]
    //   let jobnum = 0; 
    //   for(var i=0;i<this.data.length;++i){
    //     if(data === this.data[i]['id']){
    //       let num = i;
    //       jobnum = num;
    //       console.log(num)
    //     }
    //   }
      this.$router.push({
        name: "Results",
        params: {
          jobid: data,
        },
      });
    //   if(this.data[jobnum]['request_type'] === "pricing-revenue"){
    //   this.$router.push({
    //     name: "PriceOptimizationResults",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    //   }else if(this.data[jobnum]['request_type'] === "pricing-volume"){
    //      this.$router.push({
    //     name: "VolumeRecommendation",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    //   }else if(this.data[jobnum]['request_type'] === "pricing-profit"){
    //      this.$router.push({
    //     name: "ProfitRecommendation",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    //   }else{
    //   this.$router.push({
    //     name: "PriceOptimizationResults",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    // }
  },
  },
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

.q-tab__label{
  font-weight:bold;
  color:black;
}
.tbl{
  height:200px;
}
.tabl{
  height:400px;
}
.q-table__bottom
.q-badge{
  background-color:transparent;
}
.set-position {
  position: inherit;
  bottom: 22px;
  text-align: center;
}
.my-sticky-virtscroll-table {
  /* height or max-height is important */
  height: 410px;
  /* this will be the loading indicator */
}
.my-sticky-virtscroll-table .q-table__top,
.my-sticky-virtscroll-table .q-table__bottom,
.my-sticky-virtscroll-table thead tr:first-child th {
  background-color: #fff;
}
.my-sticky-virtscroll-table thead tr th {
  position: sticky;
  z-index: 1;
}
.my-sticky-virtscroll-table thead tr:last-child th {
  /* height of all previous header rows */
  top: 48px;
}
.my-sticky-virtscroll-table thead tr:first-child th {
  top: 0;
}
.heading {
  font-family: "Montserrat", sans-serif;
  color: blue;
  font-size: 1.5rem;
}
.introWindow {
  text-align: center;
  border-radius: 4px;
  padding: 1rem 1rem 0;
  background: transparent;
  /* background-image: radial-gradient(circle, #2678ca, #082f7a); */
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); */
  transition: 0.3s;
  height: 100vh;
}
.loaderClass {
  margin: 40vh 0 0 40%;
}
.nodata {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 50%;
  text-align: center;
  height: 100px;
  padding-top: 2.5rem;
  margin-top: 40vh;
  margin-left: 25%;
}
.box-h {
  align-items: center;
  background-color: #2db051;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-m {
  align-items: center;
  background-color: #fb9300;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.generate{
  color:white!important;
}
.fit{
   border-top-left-radius: 0px !important;
   border-bottom-right-radius: 0px !important;
   border-bottom-left-radius: 0px !important;
   background: white!important;
box-shadow: 0px 3px 6px #00000030;


}
.block {
    color:none!important ;
}
</style>
